import { Image } from '@mantine/core'
import ImagePlaceholder from '@/assets/image-placeholder.png'

type EventThumbnailProps = {
  path: string
}

export const EventThumbnail = ({ path }: EventThumbnailProps) => {
  return (
    <Image
      h={128}
      w={128}
      fit="contain"
      src={path}
      fallbackSrc={ImagePlaceholder}
    />
  )
}
